import { Link } from 'react-router-dom';
import { PageTransition, FadeIn } from '../components/layout';
import { ChevronRight } from 'lucide-react';

export default function MentionsLegalesPage() {
  return (
    <PageTransition>
      <section className="pt-32 pb-8 px-6 bg-gradient-to-b from-[var(--champagne)]/30 to-white">
        <div className="max-w-[800px] mx-auto text-center">
          <h1 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-light mb-4 text-[var(--charcoal)]">
            Mentions Légales
          </h1>
        </div>
      </section>

      <div className="bg-white py-4 border-b border-[var(--champagne)]">
        <div className="max-w-[1400px] mx-auto px-6">
          <nav className="flex items-center gap-2 text-sm text-[var(--charcoal)]/60">
            <Link to="/" className="hover:text-[var(--gold)] transition-colors">Accueil</Link>
            <ChevronRight size={14} />
            <span className="text-[var(--charcoal)]">Mentions Légales</span>
          </nav>
        </div>
      </div>

      <section className="py-16 px-6" data-testid="mentions-content">
        <div className="max-w-[800px] mx-auto">
          <FadeIn>
            <div className="prose prose-lg max-w-none text-[var(--charcoal)]/70">
              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mb-4">Éditeur du site</h2>
              <p>
                Manon Desroses<br />
                Entrepreneur individuel (auto-entrepreneur)<br />
                Nom commercial : Madame DSRS<br />
                SIRET : 979 786 738 00018<br />
                Adresse : Val d’Oise, Attainville (adresse privée)<br />
                Email : contact@madamedsrs.fr<br />
                Téléphone : 07 61 33 37 72
              </p>

              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mt-8 mb-4">Hébergement</h2>
              <p>
                Le site est hébergé par :<br />
                OVHcloud<br />
                2 rue Kellermann<br />
                59100 Roubaix – France<br />
                Téléphone : 1007<br />
                Site : www.ovhcloud.com
              </p>

              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mt-8 mb-4">Propriété intellectuelle</h2>
              <p>
                L’ensemble des contenus présents sur ce site (textes, images, visuels, formations, supports pédagogiques,
                livret de formation, identité visuelle, logo, etc.) est la propriété exclusive de Madame DSRS, sauf
                mention contraire.
              </p>
              <p>
                Toute reproduction, représentation, modification, publication, adaptation, totale ou partielle, de ces
                éléments, quel que soit le moyen ou le procédé utilisé, est strictement interdite sans autorisation écrite
                préalable.
              </p>
              <p>
                Toute utilisation non autorisée sera considérée comme constitutive d’une contrefaçon et pourra faire
                l’objet de poursuites conformément aux dispositions du Code de la propriété intellectuelle.
              </p>

              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mt-8 mb-4">Données personnelles</h2>
              <p>
                Les informations collectées via le site (formulaires de contact, commandes, réservations) sont destinées
                exclusivement à la gestion de la relation client.
              </p>
              <p>Les données collectées peuvent inclure :</p>
              <ul>
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone</li>
                <li>Informations nécessaires à la commande</li>
              </ul>
              <p>
                Ces données sont conservées pendant la durée strictement nécessaire au traitement des demandes et à la
                gestion de la relation commerciale.
              </p>
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d’un droit d’accès,
                de rectification, de suppression et d’opposition concernant vos données personnelles.
              </p>
              <p>
                Pour exercer ces droits, vous pouvez contacter :<br />
                contact@madamedsrs.fr
              </p>

              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mt-8 mb-4">Cookies</h2>
              <p>
                Le site utilise uniquement des cookies strictement nécessaires à son bon fonctionnement.
              </p>
              <p>
                Aucun cookie de suivi ou de tracking à des fins publicitaires ou analytiques n’est utilisé.
              </p>

              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mt-8 mb-4">Responsabilité</h2>
              <p>
                Madame DSRS s’efforce de fournir sur le site des informations aussi précises que possible. Toutefois,
                elle ne pourra être tenue responsable des omissions, des inexactitudes ou des carences dans la mise à jour.
              </p>
              <p>
                Le site peut contenir des liens vers d’autres sites. Madame DSRS ne peut être tenue responsable du
                contenu de ces sites externes.
              </p>

              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mt-8 mb-4">Conditions liées aux formations</h2>
              <p>
                Les formations proposées sont destinées à un usage strictement personnel.
              </p>
              <ul>
                <li>Le contenu des formations et supports pédagogiques est réservé aux participantes</li>
                <li>Toute reproduction, diffusion ou revente est strictement interdite</li>
                <li>Les formations sont non certifiantes (sauf mention contraire)</li>
                <li>Chaque participante reste responsable de la mise en pratique des techniques enseignées</li>
              </ul>

              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[var(--charcoal)] mt-8 mb-4">Paiement et conditions de réservation</h2>
              <p>
                Les prestations proposées sur le site peuvent faire l’objet d’un paiement en ligne sécurisé.
              </p>
              <p>
                Toute commande implique l’acceptation des présentes mentions légales et, le cas échéant, des conditions
                générales de vente.
              </p>
              <p>
                Madame DSRS se réserve le droit de refuser ou d’annuler toute commande en cas de litige ou de défaut
                de paiement.
              </p>
              <p>
                Les conditions d’annulation, de report et de remboursement sont précisées dans les conditions générales
                de vente.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>
    </PageTransition>
  );
}
